import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const EditIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "edit",
  "EditIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M11.4412 1.02209L14.9767 4.55763L6.10521 13.4292L1.85205 14.1468L2.56968 9.89363L11.4412 1.02209ZM10.346 4.00293L11.9959 5.65284L13.0911 4.55763L11.4412 2.90771L10.346 4.00293ZM11.0531 6.59565L9.40319 4.94574L3.81358 10.5353L3.47869 12.5201L5.4635 12.1853L11.0531 6.59565Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default EditIcon;
